import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { TeamType } from '@/types/filters';
import { Nullable } from '@/types/generic';
import { selectedGameNameAtom } from '../queries/game';
import { teamTypeAtom } from '../team/team';

export const gameIdAtom = atom<Nullable<number>>(null);

const gameTeamNameAtom = atom(async get => {
  const selectedGameName = await get(selectedGameNameAtom);
  const teamType = get(teamTypeAtom);

  const [homeTeamName, awayTeamName] = selectedGameName.split(' vs. ');
  return teamType === TeamType.HOME ? homeTeamName : awayTeamName;
});

export const unwrappedGameTeamNameAtom = unwrap(gameTeamNameAtom, prev => prev || '');
